import { getFeaturedArticles } from '@/mocks/articles';
import VideoCard from '@/components/feature/VideoCard';

export default function FeaturedVideos() {
  const featured = getFeaturedArticles().slice(0, 3);

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            精选推荐
          </h2>
          <a href="/" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1">
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featured.map((article) => (
            <VideoCard key={article.id} article={article} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}